import { render, staticRenderFns } from "./DocumentSpan.vue?vue&type=template&id=154e4ceb&"
import script from "./DocumentSpan.vue?vue&type=script&lang=js&"
export * from "./DocumentSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports